import { useEffect, useState } from 'react';

export const useWinePackageClasses = (showEurPrice: boolean) => {
  const slideUpDivClasses =
    'w-full flex flex-col min-[350px]:transform-none lg:transform lg:absolute lg:bottom-[80px] lg:left-0 lg:px-[12px] lg:backdrop-blur-md bg-[#F6F5F2] bg-opacity-30 lg:transition-transform duration-300 ease-in-out';

  const [classnameWithCart, setClassnameWithCart] = useState('');
  const [classnameWithoutCart, setClassnameWithoutCart] = useState('');

  useEffect(() => {
    const classnameWithCart = showEurPrice ? 'lg:translate-y-[75px]' : 'lg:translate-y-[60px]';
    const classnameWithoutCart = showEurPrice ? 'lg:translate-y-[160px]' : 'lg:translate-y-[140px]';
    setClassnameWithCart(classnameWithCart);
    setClassnameWithoutCart(classnameWithoutCart);
  }, [showEurPrice]);

  return { slideUpDivClasses, classnameWithCart, classnameWithoutCart };
};
